import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import useStyles from './RadioButton.styled';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const RadioButton = ({ value, label, onChange = () => {}, ...props }) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      value={value}
      label={label}
      className={classes.radioLabel}
      control={<Radio color="primary" className={classes.radio} onChange={onChange} />}
      {...props}
    />
  );
};

RadioButton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default RadioButton;
